import React, {memo} from 'react';
import classNames from 'classnames';

const Number = ({className, title, label, current, inactive}) => (
    <div className={classNames(className, {current, inactive})} title={title}>
        <span>{label}</span>
    </div>
);

export default memo(Number);
